export function getOperator(filterType: string): string {
  switch (filterType) {
    case 'equals':
      return 'eq';
    case 'notEqual':
      return 'neq';
    case 'contains':
      return 'contains';
    case 'notContains':
      return 'notContains';
    case 'startsWith':
      return 'startsWith';
    case 'endsWith':
      return 'endsWith';
    case 'lessThan':
      return 'lt';
    case 'lessThanOrEqual':
      return 'lte';
    case 'greaterThan':
      return 'gt';
    case 'greaterThanOrEqual':
      return 'gte';
    default:
      return 'equals';
  }
}
